<template>
  <div
    :class="[
      'c--banners_referral',
      'ltr:tw-bg-gradient-to-r rtl:tw-bg-gradient-to-l tw-from-[#ff5f6d] tw-to-[#ffc371]',
      'tw-flex tw-justify-start tw-items-center tw-gap-5',
      'tw-w-full tw-h-[75px]',
      'tw-rounded tw-shadow',
      'tw-px-5 tw-py-[15px]',
      'tw-cursor-pointer',
      'tw-text-white',
    ]"
    @click="handleProfileBannerClick"
  >
    <i class="airalo-icon-referral-1 tw-text-11" />

    <div class="tw-flex tw-justify-between tw-items-center tw-w-full">
      <div class="tw-text-[14px]/[18px] tw-font-semibold">
        {{ $t('components.referral.banner.content.v2', { amount: giveAmount }) }}
      </div>

      <i class="rtl:tw-hidden airalo-icon-arrow-right" />
      <i class="ltr:tw-hidden airalo-icon-arrow-left" />
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    computed: {
      ...mapGetters({
        giveAmount: 'multiCurrency/get_referral_give_amount',
      }),
    },

    methods: {
      handleProfileBannerClick() {
        this.$utils.sendEvent('referralBannerEvent', 'profile')
        this.$router.push(this.localePath('/profile/referral'))
      },
    },
  }
</script>
